import { Reveal, Stagger, staggerItem } from "../components/Reveal";
import { motion } from "framer-motion";
import { FEATURES } from "../data/content";
import { useSiteImages } from "../context/SiteImagesContext";

const IMG =
  "https://images.unsplash.com/photo-1544816155-12df9643f363?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function Producto() {
  const { resolve } = useSiteImages();
  return (
    <section id="producto" data-testid="producto-section" className="py-24 md:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="overline mb-6">
            <span className="text-[#D7C6A3]">03</span> &nbsp;/&nbsp; El producto
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Mucho más que una carpeta médica.
          </h2>
          <p className="text-[#4A554E] mt-6 max-w-xl leading-relaxed font-light">
            Cada detalle está pensado para que organizar tu documentación sea sencillo, elegante y
            duradero.
          </p>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-5">
          <Reveal className="lg:row-span-2 rounded-[2rem] overflow-hidden relative min-h-[340px] group">
            <img
              src={resolve("producto", IMG)}
              alt="Detalle de la carpeta VITAE"
              className="w-full h-full object-cover absolute inset-0 group-hover:scale-105 transition-transform duration-1000"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D3732]/70 to-transparent" />
            <div className="absolute bottom-0 p-8">
              <p className="font-display text-3xl text-white leading-tight">
                Diseñada para acompañarte durante años.
              </p>
            </div>
          </Reveal>

          <Stagger className="lg:col-span-2 grid sm:grid-cols-2 gap-5">
            {FEATURES.map(({ text, Icon }, i) => (
              <motion.div
                key={i}
                variants={staggerItem}
                data-testid={`feature-${i}`}
                className="bg-[#FAF9F6] border border-[#EBEBEB] rounded-3xl p-7 flex items-start gap-4 hover:bg-[#F6F1E7] transition-colors duration-500"
              >
                <div className="w-11 h-11 rounded-full bg-white border border-[#EBEBEB] flex items-center justify-center flex-shrink-0">
                  <Icon size={22} weight="light" className="text-[#8A9A6F]" />
                </div>
                <p className="text-[#2D3732] font-light pt-2">{text}</p>
              </motion.div>
            ))}
          </Stagger>
        </div>
      </div>
    </section>
  );
}
